/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener('click', function (event) {
  var toggleButton = event.target.closest('[data-description-toggle]');
  if (!toggleButton) return;
  var wrapper = toggleButton.closest('[data-description-wrapper]');
  var truncatedText = wrapper.querySelector('[data-description-truncated]');
  var fullText = wrapper.querySelector('[data-description-full]');
  var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
  truncatedText.hidden = !isExpanded;
  fullText.hidden = isExpanded;
  toggleButton.textContent = isExpanded ? 'Read more' : 'Read less';
  toggleButton.setAttribute('aria-expanded', String(!isExpanded));
});

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
